//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    figure: {
      default: "",
    },
  },
  data() {
    return {
      currentStep: 0,
      isPlaying: false,
    };
  },
  watch: {
    currentStep() {
      this.$emit("changeStep", this.currentStep);
    },
  },

  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async play() {
      this.isPlaying = true;
      if (this.isLastStep) {
        this.currentStep = -1;
      }
      while (!this.isLastStep && this.isPlaying) {
        this.currentStep += 1;
        console.log(this.currentStep);
        await this.sleep(1500);
        if (!this.isPlaying) {
          break;
        }
        if (this.currentStep > this.figure.stepsMan.length) {
          this.currentStep = -1;
          break;
        }
      }
      this.isPlaying = false;
    },
    pause() {
      this.isPlaying = false;
    },
    nextStep() {
      if (!this.isLastStep) {
        this.currentStep += 1;
        this.isPlaying = false;
      }
    },
    prevStep() {
      if (!this.isFirstStep) {
        this.currentStep -= 1;
        this.isPlaying = false;
      }
    },
  },
  computed: {
    isLastStep() {
      if (this.figure.stepsMan) {
        return this.currentStep === this.figure.stepsMan.length - 1;
      }
      return 0;
    },
    isFirstStep() {
      return this.currentStep === 0;
    },
  },
};
